export const SETTINGS_MENU_CLOSE_EVENT = 'CW-CLOSE-SETTINGS-MENU';

export const SETTINGS_MENU_OPEN_EVENT = 'CW-OPEN-SETTINGS-MENU';
